<template>
    <div>
        <!-- Title страницы -->
        <vue-headful :title="$t('isc_edit')" />
        <!-- Информация о студенте  (IUP)-->

        <vx-card v-if="!isStudent" class="mb-base my-2">
            <div class="flex align-center items-center">
                <vs-button class="mr-2 reply_btn" @click="$router.go(-1)" radius icon="reply"></vs-button>
                <h3 class="text-base lg:text-lg">{{ $t("students-list-view") }}</h3>
            </div>
            <div class="vx-row mt-2" v-if="!isStudent">
                <div class="vx-col flex-1" id="account-info-col-1">
                    <table class="block lg:table">
                        <tr>
                            <td class="font-semibold block lg:table-cell">{{ $t("fio") }}</td>
                            <td class="block lg:table-cell mb-2 lg:mb-0">
                                {{ DA.student.lastName }}
                                {{ DA.student.firstName }}
                                {{ DA.student.middleName }}
                            </td>
                        </tr>
                        <tr>
                            <td class="font-semibold block lg:table-cell">
                                {{ $t("eduGroup") }}
                            </td>
                            <td class="block lg:table-cell mb-2 lg:mb-0">{{ DA.group }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold block lg:table-cell">{{ $t("op") }}</td>
                            <td class="block lg:table-cell mb-2 lg:mb-0">{{ DA.education_program }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold block lg:table-cell">
                                {{ $t("groupOp") }}
                            </td>
                            <td class="block lg:table-cell">{{ DA.education_program_group }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <!--  Академический период -->
            <div class="vx-col flex-1 my-4">
                <v-select :options="acadPeriudItems" v-model="selectPeriud" clearable label="name"
                          :reduce="(item) => item.uid" :placeholder="$t('select_academPeriud')" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          @search:blur="getDesciplines" />
            </div>
        </vx-card>
        <!-- Выбор всех периодов (RegisterDiscipline) -->
        <vx-card v-else-if="!showNotDiscipline" v-show="acadFilter" :title="$t('acad_periods')" class="mb-base my-2">
            <div class="vx-col flex-1 my-4">
                <v-select :options="acadPeriudItems" v-model="selectPeriud" clearable label="name"
                          :placeholder="$t('acad_periods')" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          @search:blur="filterDesciplinesOnAcadPeriud" />
            </div>
        </vx-card>

        <div v-if="!showNotDiscipline" id="todo-app"
             class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden" style="height: 80vh">
            <vs-sidebar v-if="isStudent" class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose"
                        :hidden-background="clickNotClose" v-model="isSidebarActive">
                <!-- ФИЛЬТРЫ -->
                <component :is="'VuePerfectScrollbar'" ref="filterScroll" class="custom_scroll" :settings="settings"
                           :key="$vs.rtl">
                    <div class="todo__filters-container">
                        <div v-if="!loading">
                            <div class="px-6 py-4">
                                <!-- Кнопка сбросить фильтр -->
                                <div class="flex cursor-pointer" @click="clearAllSelects">
                                    <feather-icon icon="FilterIcon" svgClasses="h-6 w-6"></feather-icon>
                                    <span class="text-lg ml-3">{{
                                            $t("show_all")
                                        }}</span>
                                </div>
                            </div>

                            <vs-divider class="mb-0 mt-0"></vs-divider>
                            <!-- Список селектов (Рендер происходит по структуре) -->
                            <MySelect v-for="select in listSelects" :data="select"
                                      :key="select.nameI18nAndQueryParam" />
                            <div class="px-6 py-4">
                                <vs-button class="w-full" @click="useFilter">
                                    {{$t("apply")}}
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </component>
            </vs-sidebar>
            <div :class="{ 'sidebar-spacer': clickNotClose }"
                 class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">
                <!-- sidebar filter -->
                <div v-if="isStudent" class="flex border d-theme-dark-bg items-center">
                    <feather-icon class="md:inline-flex ml-4 mr-4 my-2 cursor-pointer" icon="MenuIcon"
                                  @click.stop="toggleSidebar(true)" />
                </div>
                <vs-tabs v-model="activeTab">
                    <vs-tab @click="selectDiscipline" :label="$t('disciplines_2')">
                        <component :is="'VuePerfectScrollbar'" ref="emcListScroll" :settings="settings" :key="$vs.rtl">
                            <!-- Список дисциплин-->

                            <table class="table" v-if="listDisciplines.length !== 0">
                                <thead class="thead-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">{{$t('disciplines_2')}}</th>
                                    <th scope="col"> {{$t("credits")}}</th>
                                    <th scope="col">{{$t('act')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in listDisciplines" :key="`d_${index}`" :style="[
                                        { transitionDelay: index * 0.1 + 's' },
                                    ]">
                                    <th>{{index+1}}</th>
                                    <td  @click="!item.hide ? updateOpen(item) : ''" class="cursor-pointer">
                                        {{
                                            item.discipline
                                        }}</td>
                                    <td>{{
                                            item.credit
                                        }}</td>
                                    <td>
                                        <vs-chip v-if="item.hide" class="mr-2 ml-2 text-sm" transparent
                                                 color="danger">{{
                                                $t(
                                                    "deactivated_discipline"
                                                )
                                            }}
                                        </vs-chip>
                                        <br>
                                        <div v-if="isAdvisor" class="flex">
                                            <vx-tooltip v-if="!item.hide" position="left"
                                                        :text="$t('deactivate_discipline')">
                                                <vs-button @click="deactivateD(item)" icon="delete" color="danger">
                                                </vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip v-else position="left" :text="$t('deactivate_discipline')">
                                                <vs-button @click="activateD(item)" icon="replay"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>

                                <tfoot>

                                <td></td>

                                <td>
                                    <vs-button  v-if="isStudent"
                                                v-show="!loading"
                                                color="success"
                                                @click="notyAdvisor"
                                                class="my-4 mx-4">
                                        {{ $t("send-advisor") }}
                                    </vs-button>
                                </td>


                                </tfoot>
                            </table>

                            <!-- Сообщение данных нет -->
                            <div class="mt-4 ml-5 mr-5" v-else>
                                <vs-alert active="true">
                                    {{
                                        acadFilter
                                            ? $t("select_academPeriud")
                                            : $t("no_data_text")
                                    }}
                                </vs-alert>
                            </div>
                        </component>
                    </vs-tab>
                    <!-- Итоговая аттестация -->
                    <vs-tab v-if="isStudent" @click="selectControlsForm" :label="$t('itog-atestat')">
                        <ControlForms :data="controlFormsData" :acadFilter="acadFilter" />
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>

        <!-- ПРОСМОТР Десциплин и редактирование -->
        <Detail :data="selectedItemDist" @closesidebar="isSidebarActiveDist = false"
                :isSidebarActiveDist="isSidebarActiveDist" />

        <!-- Регистрация окончена показ профиля эдвайзера -->

        <vx-card v-if="showNotDiscipline" class="mb-base my-2">
            <div class="flex flex-col" style="align-items: center">
                <h3>{{ $t("register-over") }}</h3>
                <h3>{{ $t("Pleaserefertoyour") }} {{ $t("advisory") }}</h3>
            </div>

            <div class="mt-4">
                {{ profileAdvisor.lastName }} {{ profileAdvisor.firstName }}
                {{ profileAdvisor.middleName }}
            </div>
            <span style="cursor: pointer">Email:
                <a :href="'mailto:' + profileAdvisor.email">
                    {{ profileAdvisor.email }}
                </a></span>
        </vx-card>
    </div>
</template>

<script>
import Detail from "./Detail";
import MySelect from "./Multiselect";
import ControlForms from "./ControlFromsView";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
    mapGetters,
    mapMutations
} from "vuex";

export default {
    name: "ViewAndEditStudyPlan",
    props: {
        isStudent: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Detail,
        VuePerfectScrollbar,
        MySelect,
        ControlForms,
    },
    data() {
        return {
            viewDetail: false,
            clickNotClose: false,
            showNotDiscipline: false,
            isSidebarActive: true,
            isSidebarActiveDist: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },
            data: {},
            uidAllPeriods: "all",
            uidAdviser: null,
            selectPeriud: null,
            acadPeriudItems: [],
            acadFilter: false,
            activeTab: 0,
            globalData: [],
            profileAdvisor: {},
            listDisciplines: false,
            listControlForms: [],
            selectedItemDist: {},
            loading: false,
            controlFormsData: [],
            listSelects: [{
                nameI18nAndQueryParam: "study_year",
                endpoint: "common/study_years/?my=1",
                required: true,
            },
                {
                    nameI18nAndQueryParam: "study_plan",
                    endpoint: "user/my_study_plans_version2/",
                    dependents: ["study_year"],
                    required: true,
                },

                {
                    nameI18nAndQueryParam: "acad_periods",
                    endpoint: "common/acad_periods_for_reg/copy/",
                    params: ["study_plan","study_year"],
                    dependents: ["study_year", "study_plan"],
                    required: true,
                },
            ],
        };
    },

    created() {
        if (!this.isStudent) {
            if (this.DA === null) {
                this.$router.push({
                    name: "applications_review_in_isc"
                });
            }
            this.getAcadsPeriud();
        } else {
            this.setDA({});
        }
        console.log(this.DA)
    },
    mounted() {
        this.checkSelectsDataForRequest();
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
    },
    computed: {
        ...mapGetters({
            // getter из store со всеми данными
            DA: "ApplicationForISC/application",
            USER: "user/STATE",
        }),

        windowWidth() {
            return this.$store.state.windowWidth;
        },

        isAdvisor() {
            return this.USER.roles.is_supervisor
        }
    },
    methods: {
        ...mapMutations({
            setDAParams: "ApplicationForISC/SET_DA_PARAMS",
            setDA: "ApplicationForISC/setDA",
        }),

        deactivateD(item) {
            try {
                const res = this.$http.put(
                    `advisors/discipline/${ item.uid }/deactivate/`
                );

                const idx = this.listDisciplines.findIndex(el => el.uid === item.uid);
                this.listDisciplines[idx].hide = true;

                this.$vs.notify({
                    title: this.$t("deactivated_discipline"),
                    color: "success",
                });
            } catch {
                this.$vs.notify({
                    title: this.$t("error") + "!",
                    color: "danger",
                });
            }
        },
        activateD(item) {
            try {
                const res = this.$http.put(
                    `advisors/discipline/${ item.uid }/activate/`
                );

                const idx = this.listDisciplines.findIndex(el => el.uid === item.uid);
                this.listDisciplines[idx].hide = false;

                this.$vs.notify({
                    title: this.$t("successful"),
                    color: "success",
                });
            } catch {
                this.$vs.notify({
                    title: this.$t("error") + "!",
                    color: "danger",
                });
            }
        },
        getAcadsPeriud() {
            // Получение периуда

            this.acadPeriudItems = this.DA.acad_periods.map((c) => {
                return {
                    name: c.acad_period,
                    uid: c.uid
                };
            });
            if (this.isStudent) {
                // Добавление периуда за весь учебный год
                this.acadPeriudItems.push({
                    name: "На весь учебный год",
                    uid: "all",
                });
            }
        },
        // Фильтрация периода (если выбраны все периоды)
        filterDesciplinesOnAcadPeriud() {
            // Если выбранная вкладка дисциплины
            if (this.activeTab === 0) {
                this.listDisciplines = this.globalData.filter(
                    (c) => c.name === this.selectPeriud
                )[0].disciplines;
                // Если итог аттестация
            } else {
                this.controlFormsData = this.listControlForms.filter(
                    (c) => c.name === this.selectPeriud
                )[0].disciplines;
            }
        },
        // Очистка основных фильтров
        clearAllSelects() {
            this.$router.replace({
                name: this.$route.name,
                query: {}
            });
        },
        // Запросы фильтров
        checkSelectsDataForRequest() {
            this.check = false;
            // Получаю массив из обязательных полей из структуры
            const listRequired = this.listSelects.filter((obj) => obj.required);
            // Получаю массив из имеющихся заполненных обязательных селектов
            const numberQueryRequired = Object.keys(
                this.$route.query
            ).filter((key) =>
                this.listSelects.some(
                    (obj) => obj.nameI18nAndQueryParam === key && obj.required
                )
            );
            // Сравниваю, что все обязательные селекты заполнены и делаю запрос
            if (numberQueryRequired.length === listRequired.length) {
                this.useFilter();
            }
        },
        // Кнопка применить фильтры
        useFilter() {
            // пармаетры из роуа
            const obj = this.$route.query;
            if (
                "study_plan" in obj &&
                "study_year" in obj &&
                "acad_periods" in obj
            ) {
                //  Добоавлем параметры в state
                this.setDAParams(obj);
                this.selectPeriud = obj.acad_periods;
                // Запросы
                this.getDesciplines();
                this.getControlForms();
                // Скрываем сайдбар
                this.toggleSidebar(false);
            } else {
                this.$vs.notify({
                    title: this.$t("error"),
                    text: this.$t("Fillallfields"),
                    color: "warning",
                });
            }
        },
        // Получение списка дисцеплин

        async getDesciplines() {
            this.$vs.loading();
            this.loading = true;
            try {
                const response = (
                    await this.$http.get("user/my_discipline/copy/", {
                        params: {
                            // Деволтный параметры
                            study_year: this.DA.study_year,
                            study_plan: this.DA.study_plan,

                            ...(this.selectPeriud !== this.uidAllPeriods && {
                                acad_period: this.selectPeriud,
                            }),

                            ...(this.selectPeriud === this.uidAllPeriods && {
                                reg_period: this.DA.reg_period,
                            }),
                        },
                    })
                ).data;

                this.globalData = response;

                if (this.activeTab === 1) {
                    // Если активный таб итог аттестации
                    this.selectControlsForm();
                } else {
                    this.selectDiscipline();
                }
            } catch (e) {
                if (e.uid !== undefined) {
                    // Показ профиля эдвайзера если регистрация окончена
                    this.showNotDiscipline = true;
                    this.uidAdviser = e.uid;
                    this.profileAdvisor = (
                        await this.$http(`user/profile/${ e.uid }`)
                    ).data;
                } else
                    this.$vs.notify({
                        title: this.$t("error"),
                        color: "danger",
                    });
            }
            this.loading = false;
            this.$vs.loading.close();
        },
        async getControlForms() {
            this.$vs.loading();
            this.loading = true;
            // Для удобства
            const pageName = this.$route.name;

            try {
                const response = await this.$http
                    .get("user/my_discipline/control_forms/", {
                        params: {
                            study_year: this.DA.study_year,
                            study_plan: this.DA.study_plan,

                            ...(this.selectPeriud !== this.uidAllPeriods && {
                                acad_period: this.selectPeriud,
                            }),

                            ...(this.selectPeriud === this.uidAllPeriods && {
                                reg_period: this.DA.reg_period,
                            }),
                        },
                    })
                    .then((response) => response.data);

                this.controlFormsData = response;
                this.listControlForms = this.controlFormsData;
                this.loading = false;
            } catch (e) {}
        },
        // Если выбранны все периоды
        selectDiscipline() {
            this.activeControlForms = false;
            if (this.DA.acad_period === "all") {
                this.acadFilter = true;
                this.selectPeriud = "";
                this.listDisciplines = [];
                // Заполняем селект период
                this.acadPeriudItems = this.globalData.map((c) => c.name);
            } else {
                this.acadFilter = false;
                this.listDisciplines = this.globalData;
            }
        },
        selectControlsForm() {
            if (this.DA.acad_period === "all") {
                this.acadFilter = true;
                this.selectPeriud = "";
                this.controlFormsData = [];
                // Заполняем селект период
                this.acadPeriudItems = this.listControlForms.map((c) => c.name);
            } else {
                this.acadFilter = false;
            }
        },
        // Отправить эдвайзеру
        async notyAdvisor() {
            const response = await this.$http.post("user/notify_advisor/", {
                study_plan: this.DA.study_plan,
            });

            if (response.data.message === "ok") {
                this.$vs.notify({
                    title: this.$t("succesful"),
                    color: "success",
                });
            } else {
                this.$vs.notify({
                    title: this.$t("error"),
                    color: "danger",
                });
            }
        },
        // Открытие сайдбара редактирования
        updateOpen(item) {
            this.selectedItemDist = item;
            this.isSidebarActiveDist = true;
        },
        // Установка ширины для мобилки/декстопа
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false;
            } else {
                this.isSidebarActive = this.clickNotClose = true;
            }
        },
        // Функция открытия sidebar с фильтрами для моб устройств
        toggleSidebar(value = false) {
            if (!value && this.clickNotClose) return;
            this.isSidebarActive = value;
        },
    },
};

</script>
<style lang="scss" scoped>
.table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;

    td,
    th {
        padding: .75rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
    }
}


#todo-app::v-deep {
    .vs-sidebar--items {
        overflow-y: auto !important;
        align-items: stretch;
        display: flex;
    }
}

</style>
<style lang="scss">
.todo__filters-container {
    .multiselect__single {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

.filters_scroll_area {
    position: relative;
    width: 100%;
    margin: auto;

    &.aside_scroll_teacher {
        height: calc(100% - 67px);
    }

    &:not(.aside_scroll_teacher) {
        height: 100%;
    }
}

@media only screen and (max-width: 800px) {
    .reply_btn {
        min-width: 30px;
        max-height: 30px;
        max-width: 30px;
    }
}

@import "@/assets/scss/vuexy/apps/todo.scss";

</style>
